import React from 'react';
import { Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

export const CreateButton = ({ children = 'Crear', startIcon, ...props }) => {
  return (
    <Button
      variant="contained"
      color="success"
      size="small"
      sx={{ minHeight: 42 }}
      startIcon={startIcon || <AddCircleOutlineOutlinedIcon />}
      {...props}
    >
      {children}
    </Button>
  );
};

export const SaveButton = ({ children = 'Guardar', startIcon, ...props }) => {
  return (
    <LoadingButton
      variant="contained"
      color="primary"
      size="small"
      sx={{ minHeight: 42 }}
      startIcon={startIcon || <SaveOutlinedIcon />}
      {...props}
    >
      {children}
    </LoadingButton>
  );
};

export const SecondaryActionButton = ({ children, ...props }) => {
  return (
    <Button
      variant="outlined"
      color="primary"
      size="small"
      sx={{ minHeight: 42 }}
      {...props}
    >
      {children}
    </Button>
  );
};
